import { put, call, delay, select } from "redux-saga/effects";
import OtherActions from 'stores/leadbest-official-website/other/actions';

import errorHandlerSaga from '../errorHandlerSaga';
import {
    postContact, postEmail, getBanner
} from 'services/leadbest-official-website/otherApi';

export function* postContactSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(postContact, payload);
        yield put(OtherActions.postContactSuccess(res));
        yield put(OtherActions.snackbarLCGRequest({ visible: true, message: "snackbar.contact.success" }))
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(OtherActions.postContactError(errorHandler));
    }
}

export function* postEmailSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(postEmail, payload);
        yield put(OtherActions.postEmailSuccess(res));
        yield put(OtherActions.snackbarLCGRequest({ visible: true, message: "snackbar.email.success" }))
    } catch (error:any) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(OtherActions.postEmailError(errorHandler));
        if (error.status == 400) {
            yield put(OtherActions.snackbarLCGRequest({ visible: true, message: "snackbar.email.error" }))
        }
    }
}

export function* snackbarLCGSaga(action: any): Generator<any, any, any> {
    try {
        yield put(OtherActions.setSnackbarLCG({ ...action.payload }));
    } catch (e) {

    }
}

export function* getBannerSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getBanner, payload);
        yield put(OtherActions.getBannerSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(OtherActions.getBannerError(errorHandler));
    }
}